import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Routes } from 'src/app/core/constants/routes';
import { Message } from 'src/app/core/class/message';
import { CommonService } from 'src/app/core/services/common.service';
import { BaseComponent } from 'src/app/shared/components/base/base.component';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html'
})
export class PageNotFoundComponent extends BaseComponent  implements OnInit {
  public href: string = '';
  public linkHome: string = '';
  constructor(
    private router: Router,
    public commonService: CommonService,
    public message: Message,
    private translate: TranslateService,
    ) {
    super(commonService, message);
   }

  ngOnInit() {
    this.setLinkHomeValue();
  }

  /*
  * Get current URL an check to routerLink to the fit page
  */
  setLinkHomeValue() {
    this.href = this.router.url;
    if (this.href.includes(Routes.ENTERPRISE_HOME)) {
      this.linkHome = Routes.SLASH + Routes.ENTERPRISE_HOME;
    }
  }

  login() {
    this.router.navigate([Routes.SLASH + Routes.ENTERPRISE_LOGIN]);
  }

  /**
   * <pre>
   * <b>Method name: onChangeLanguage</b>
   * <b>Explanation: </b> Method setting change langauge
   * </pre>
   * @author GCS 2019/08/26 by phuongtq
   *
   */
  onChangeLanguage(languageSelected: string) {
    this.setLanguagelocalStored(languageSelected);
    this.translate.use(this.getLanguagelocalStored());
    this.checkIconLanguage(this.getLanguagelocalStored());
  }
}
